export default __webpack_public_path__ + "36ecfb231c87af5b5b4c2cd096d60bbf.mp3";